export default __webpack_public_path__ + "static/media/strawberries.4f12c428.JPG";